module.exports = __webpack_public_path__ + "static/media/HomeNav.41eb91d4.svg";